module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--intersport-312f5c7a37c3da1393fbc750a97bf75a.jpg";